import React from "react";

import FilterChip from "js/components/Dashboard/FilterChip";

type ContractFilters = {
  status?: string;
  is_active?: string;
};

interface ContractFiltersProps {
  onFilterChange: (filters: ContractFilters) => void;
  filters: ContractFilters;
}

const ContractFilters: React.FC<ContractFiltersProps> = ({
  onFilterChange,
  filters,
}) => {
  const handleFilterChange = (key: keyof ContractFilters, value?: string) => {
    const newFilters: ContractFilters = { ...filters };
    if (value == null || value === "") {
      delete newFilters[key];
    } else {
      newFilters[key] = value;
    }
    onFilterChange(newFilters);
  };

  return (
    <div className="flex flex-wrap gap-2">
      <FilterChip
        label="Estado"
        value={filters.status}
        onChange={(value) => handleFilterChange("status", value)}
        options={[
          { label: "Pendiente", value: "created" },
          { label: "Pendiente de Firma", value: "pending_signature" },
          { label: "Firmado", value: "signed" },
          { label: "Completado", value: "completed" },
          { label: "Cancelado", value: "cancelled" },
        ]}
      />

      <FilterChip
        label="Activo"
        value={filters.is_active}
        onChange={(value) => handleFilterChange("is_active", value)}
        options={[
          { label: "Activo", value: "true" },
          { label: "Inactivo", value: "false" },
        ]}
      />
    </div>
  );
};

export default ContractFilters;
